import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { FormElementsSidebar, DropZone } from "./BuildElements";

import selectIcon from "../../../assets/images/dropdown-bar.svg";
import dateIcon from "../../../assets/images/calendar.svg";
import textFieldIcon from "../../../assets/images/text-box-edit.svg";
import textAreaIcon from "../../../assets/images/poll-h.svg";
import radioIcon from "../../../assets/images/radio-button.svg";
import checkboxIcon from "../../../assets/images/checkbox.svg";
import numberIcon from "../../../assets/images/hastag.svg";
import fileUploadIcon from "../../../assets/images/upload.svg";

const FORM_ELEMENTS = [
  {
    type: "checkbox-group",
    label: "Checkbox Group",
    icon: checkboxIcon,
  },
  { type: "file", label: "File Upload", icon: fileUploadIcon },
  { type: "number", label: "Number", icon: numberIcon },
  {
    type: "radio-group",
    label: "Radio Group",
    icon: radioIcon,
  },
  {
    type: "select",
    label: "Select",
    icon: selectIcon,
  },
  { type: "text", label: "Text Field", icon: textFieldIcon },
  {
    type: "textarea",
    label: "Text Area",
    icon: textAreaIcon,
  },
];

const ModernFormBuilder = ({ formData, setFormData }) => {
  const handleDeleteFormItem = (key) => {
    setFormData((prev) => prev.filter((item) => item.key !== key));
  };

  const handleUpdateFormItem = (updatedItem) => {
    setFormData((prev) =>
      prev.map((item) => (item.key === updatedItem.key ? updatedItem : item)),
    );
  };

  const handleAddOption = (key) => {
    setFormData((prev) =>
      prev.map((item) => {
        if (item.key !== key) return item;

        const num = item.values.length + 1;
        const newOption = {
          label: `Option ${num}`,
          value: `Option ${num}`,
        };

        return {
          ...item,
          values: [...item.values, newOption],
        };
      }),
    );
  };

  const handleUpdateOptions = (key, optionIndex, value) => {
    setFormData((prev) =>
      prev.map((item) => {
        if (item.key !== key) return item;

        const newOptions = item.values.map((option, i) =>
          i === optionIndex ? { label: value.value, value: value.value } : option,
        );

        return { ...item, values: newOptions };
      }),
    );
  };

  const handleDeleteOptions = (key, optionValue) => {
    setFormData((prev) =>
      prev.map((item) => {
        if (item.key !== key) return item;

        return {
          ...item,
          values: item.values.filter((option) => option.value !== optionValue),
        };
      }),
    );
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="flex gap-6">
        <DropZone
          formData={formData}
          setFormData={setFormData}
          handleDeleteFormItem={handleDeleteFormItem}
          handleUpdateFormItem={handleUpdateFormItem}
          handleAddOption={handleAddOption}
          handleUpdateOptions={handleUpdateOptions}
          handleDeleteOptions={handleDeleteOptions}
          FORM_ELEMENTS={FORM_ELEMENTS}
        />
        <FormElementsSidebar FORM_ELEMENTS={FORM_ELEMENTS} />
      </div>
    </DndProvider>
  );
};

export default ModernFormBuilder;
